import { CarouselFeature } from "./feature-base.js";
class SkipListingFeature extends CarouselFeature {
  constructor(host) {
    super(host);
    this.handleSkipListing = (e) => {
      e.preventDefault();
      this.skipListingTarget.tabIndex = 0;
      this.skipListingTarget.addEventListener("focus", this.targetFocused, {
        once: true,
        passive: true
      });
      this.skipListingTarget.focus();
    };
    this.targetFocused = () => {
      this.skipListingTarget.addEventListener("blur", this.resetTarget, {
        once: true,
        passive: true
      });
    };
    this.resetTarget = () => {
      this.skipListingTarget.tabIndex = -1;
    };
    this.destroy = () => {
      this.skipListingTarget.removeEventListener("focus", this.targetFocused);
      this.skipListingTarget.removeEventListener("blur", this.resetTarget);
    };
    this.skipListingButton = host.shadow.querySelector("#skip-link");
    this.skipListingTarget = host.shadow.querySelector("#skiplisting");
  }
  connectedCallback() {
    this.skipListingButton.addEventListener("click", this.handleSkipListing);
  }
  disconnectedCallback() {
    this.skipListingButton.removeEventListener("click", this.handleSkipListing);
    this.destroy();
  }
}
export {
  SkipListingFeature
};
